import Glide from "@glidejs/glide";
import useNcId from "hooks/useNcId";
import React, { FC, useEffect, useMemo, useRef, useState } from "react";
import NcImage from "shared/NcImage/NcImage";
import NextPrev from "shared/NextPrev/NextPrev";
import { Link } from "react-router-dom";

export interface GallerySliderProps {
  className?: string;
  ratioClass?: string;
  uniqueID?: string;
  href?: string;
  galleryImgs?: any; // Add galleryImgs prop to accept images from API
}

const LocationHomeGallerySlider: FC<GallerySliderProps> = ({
  className = "",
  galleryImgs,
  ratioClass = "aspect-w-4 aspect-h-3",
  uniqueID = "uniqueID",
  href = "/listing-stay-detail",
}) => {
  const server = process.env.REACT_APP_SERVER_URL;

  const UNIQUE_CLASS = `gallerySlider__${uniqueID}` + useNcId();

  let MY_GLIDEJS = useMemo(() => {
    return new Glide(`.${UNIQUE_CLASS}`, {
      perView: 1,
      gap: 0,
      keyboard: false,
    });
  }, [UNIQUE_CLASS]);

  useEffect(() => {
    setTimeout(() => {
      // Check if document is defined before using it
      if (typeof document !== "undefined") {
        const element = document.querySelector(`.${UNIQUE_CLASS}`);
        if (element) {
          MY_GLIDEJS.mount();
        } else {
          // Handle missing DOM element gracefully
        }
      }
    }, 10);
  }, [MY_GLIDEJS, UNIQUE_CLASS, galleryImgs]);

  const renderDots = () => {
    return (
      <div
        className="glide__bullets flex items-center justify-center absolute bottom-2 left-1/2 transform -translate-x-1/2 space-x-1.5"
        data-glide-el="controls[nav]"
      >
        {galleryImgs &&
          galleryImgs.map((_: any, i: React.Key | null | undefined) => (
            <button
              className="glide__bullet w-1.5 h-1.5 rounded-full bg-neutral-300"
              key={i}
              data-glide-dir={`=${i}`}
            />
          ))}
      </div>
    );
  };

  const renderSliderGallery = () => {
    const server = process.env.REACT_APP_SERVER_URL;
    return (
      <div className={`${UNIQUE_CLASS} relative group overflow-hidden`}>
        <div className="glide__track" data-glide-el="track">
          <ul className="glide__slides">
            {galleryImgs &&
              galleryImgs.map((item: any, index: React.Key | null | undefined) => (
                <li key={index} className="glide__slide">
                  <Link to={href} className={`block ${ratioClass}`}>
                    <NcImage src={process.env.REACT_APP_CLOUD_FRONT + item} />
                  </Link>
                </li>
              ))}
          </ul>
        </div>

        {/* DOTS */}
        <div className="absolute inset-x-0 h-10 -bottom-4 bg-gradient-to-t from-neutral-900"></div>
        {renderDots()}

        {/* NAV */}
        <div className="absolute flex justify-between transition-opacity transform -translate-y-1/2 opacity-0 group-hover:opacity-100 top-1/2 inset-x-2">
          <NextPrev className="justify-between w-full" btnClassName="w-8 h-8" />
        </div>
      </div>
    );
  };

  return (
    <div className={`nc-GallerySlider ${className} `} data-nc-id="GallerySlider">
      {renderSliderGallery()}
    </div>
  );
};

export default LocationHomeGallerySlider;
